import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseHref } from "service/api";

type SiteResponse = {
  logo: string;
  smallLogo: string;
  siteMainEmail: string;
  mainUrl: string;
  name: string;
  privacyAndPolicyUrl: string;
  termsAndConditionsUrl: string;
  frontWalletSecondaryLogo: string;
  frontWalletAuthPageColor: string;
  registrationType: string;
  favicon: string;
  btcManualSellAddress: string | null;
  ethErc20ManualSellAddress: string | null;
  trxTrc20ManualSellAddress: string | null;
  multilanguage: boolean;
};

export type AgreementDto = {
  id: number;
  text: string;
  keyWords: string | null;
  link: string | null;
  translations?: Record<
    string,
    { text: string; keyWords?: string | null }
  > | null;
};

export const siteApi = createApi({
  reducerPath: "siteApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseHref,
    credentials: "include",
  }),
  tagTypes: ["Site", "Agreements"],
  endpoints: (builder) => ({
    getSite: builder.query<SiteResponse, void>({
      query: () => `/get-site`,
      providesTags: ["Site"],
    }),

    getAgreementsList: builder.query<
      { result: boolean; agreements: AgreementDto[] },
      void
    >({
      query: () => `/agreements`,
      providesTags: ["Agreements"],
    }),
  }),
});

export const { useGetSiteQuery, useGetAgreementsListQuery } = siteApi;
